import reusables from '@styles/theme/reusables';

export default {
  icon: ({ size, color, margin, padding, hover }, addSx) => ({
    display: 'inline-flex',
    m: `${margin}`,
    p: `${padding}`,

    svg: {
      width: size,
      height: 'auto',

      'path, rect': {
        fill: `${color}`,
        ...reusables.mainTransition('fill', 'ease-in', '.1s'),
      },
    },

    '&:hover svg': {
      'path, rect': {
        ...(hover ? { fill: `${hover}` } : {}),
      },
    },

    ...addSx,
  }),
};
